const API_ROOT = (process.env.NODE_ENV === "production")
  ? "https://api.vanhouttejp.be"
  : "http://localhost:3000";

export default {
  API_ROOT
};
